

export const WorkUploadChart = {
    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label || '';
                const value = tooltipItem.yLabel;
                return `${label}: ${value} Nos`;
            }
        }
    },

    layout: {
        padding: {
            top: 10,
            bottom: 10
        }
    },
    legend: {
        display: false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black',
            
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

    scales: {

        xAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            barThickness: 40,

            ticks: {
                autoSkip: false,

            }
        }],

        yAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            ticks: {
                beginAtZero: true
            }
        }]
    }
}



export const WorkAssign = {
    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label || '';
                const value = tooltipItem.yLabel;
                return `${label}: ${value} Nos`;
            }
        }
    },

    layout: {
        padding: {
            top: 10,
            bottom: 10,
        },
    },
    legend: {
        display:false
    },

    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black',
            
        },
        legend: {
            display: false
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

    scales: {

        xAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            barThickness: 30,


            ticks: {
                autoSkip: false,

            }
        }],

        yAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            ticks: {
                beginAtZero: true
            }
        }]
    }
}




export const Dcoptions = {

    layout: {
        padding: {
            // top: 70,
            // bottom: 10
        }
    },
    legend: {
        // position: 'chartArea',
        // align: 'start',
        display: false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black'
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

    scales: {

        xAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            barThickness: 30,
            ticks: {
                autoSkip: false,

            }
        }],
        yAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            ticks: {
                beginAtZero: true
            }
        }]
    }
}



export const Pieoptions = {
    layout: {
        padding: {
            top: 10,
            bottom: 0
        }
    },
    legend: {
        display:false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black'
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 12,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },
}
  
    // scales: {
    //     xAxes: [{
    //         gridLines: {
    //             drawOnChartArea: false
    //         },
    //         ticks: {
    //             autoSkip: false,
    //             maxRotation: 90,
    //             minRotation: 90
    //         }
    //     }],
    //     yAxes: [{
    //         gridLines: {
    //             drawOnChartArea: false
    //         }
    //     }]
    // }


export const ServicePieoptions = {
    layout: {
       
    },
    legend: {
        display:false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black'
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 0,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },
}
